import { createContext, useCallback, useContext, useState } from 'react';
import { requestRemoteData } from '../API/api';

const COMERCIAL_CLIENTE_ENDPOINT = 'comercial/cliente';

const ComercialContext = createContext();

export const fetchClienteByNumCliente = (numCliente) => {
    return requestRemoteData(`${COMERCIAL_CLIENTE_ENDPOINT}/${numCliente}`);
};

export const fetchClientesComercial = () => {
    return requestRemoteData('comercial/clientes');
};

export const ComercialContextProvider = ({ children }) => {
    const [actingAsCliente, setActingAsClienteState] = useState(() => {
        const stored = sessionStorage.getItem('actingAsCliente');
        return stored ? JSON.parse(stored) : null;
    });

    const setActingAsCliente = useCallback((cliente) => {
        if (cliente) {
            sessionStorage.setItem('actingAsCliente', JSON.stringify(cliente));
        } else {
            sessionStorage.removeItem('actingAsCliente');
        }
        setActingAsClienteState(cliente);
    }, []);

    const clearActingAsCliente = useCallback(() => {
        sessionStorage.removeItem('actingAsCliente');
        setActingAsClienteState(null);
    }, []);

    const isComercialMode = actingAsCliente != null;

    return (
        <ComercialContext.Provider value={{ actingAsCliente, setActingAsCliente, clearActingAsCliente, isComercialMode }}>
            {children}
        </ComercialContext.Provider>
    );
};

export const useComercialContext = () => useContext(ComercialContext);
